import { Utils, useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useConsortiumActions } from '../../../../../../store/consortium/actions';
import { CustomerItemDataProps } from '../../../../utils/types';

import { DesktopItem } from './desktop';
import { MobileItem } from './mobile';
import { TabletItem } from './tablet';

export interface ResponsiveItemProps {
  item: CustomerItemDataProps;
  handleSelect: () => void;
}

export interface ItemProps {
  item: CustomerItemDataProps;
}

export const Item: React.FC<ItemProps> = ({ item }) => {
  const { handleSelectCustomerItem, updateCustomerStatus } = useConsortiumActions();

  const handleSelect = () => {
    handleSelectCustomerItem(item);
    updateCustomerStatus('closed');
  };

  const props = {
    handleSelect,
    item,
    availableBalanceFormatted: Utils.Mask.Money(item.availableBalance || 0),
  };

  const responsiveItem = useBreakpointValue({
    base: <MobileItem {...props} />,
    sm: <TabletItem {...props} />,
    lg: <DesktopItem {...props} />,
  });

  return responsiveItem;
};
